import dynamic from "next/dynamic";
import PressGridConfig from "./press-grid-config";
import PressGridAdvancedConfig from "./press-grid-advanced-config";
const PressGridComponent = dynamic(()=>import("./press-grid-component"));
export default {
    PressGridComponent,
    PressGridConfig,
    PressGridAdvancedConfig
};
